import type { FaireProductEntity } from "../../entity_types/product";

export const p_d52s2gk72u: FaireProductEntity = {
  token: "p_d52s2gk72u",
  type: "product",
  name: "Mama Heishi Bracelets",
  brandToken: "b_cyq0jgl0zz",
  brandName: "Savvy Bling",
  imageUrl:
    "https://cdn.faire.com/fastly/0717c7fda3a301f3994e3ffbc1702e0d22d4cd96b1b73df307875214d5ea1c73.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e0f11ca1fab49a14b373a0e2a6a20b9d4b001b2223056a7b012e5110c9ac6758.jpeg",
    "https://cdn.faire.com/fastly/e8d7f3008f56649347b020d46561fb3fb3552adda83aa845c6d1c0f6d4a15fa2.jpeg",
    "https://cdn.faire.com/fastly/c7a914f23db0326f3f2db7f40ad06e02b88fe49ad4cd4e4122cece455cd9ec9f.jpeg",
    "https://cdn.faire.com/fastly/e066d524fad6c708fbfb59a444f1cd418ac66932d9daabef0597ea2c37f6b695.jpeg",
    "https://cdn.faire.com/fastly/157cfb3c38b794e746da214c1ef3cb9952ad255332daf326b3a3d2d222afddeb.jpeg",
    "https://cdn.faire.com/fastly/9042963fff9e3854c0d8d89f29d869b945ce05593dc16c15c16504d9a3eccfc2.jpeg",
    "https://cdn.faire.com/fastly/07f20de4c86da7b1e3dbf6a050a29144fdc3032aa58dcfdd8bdcf6038004a4fc.jpeg",
    "https://cdn.faire.com/fastly/1f0d9670f8f1d2ee21e2b49818a312439625d7b8371283e601e7e465fe9aa4ae.jpeg",
    "https://cdn.faire.com/fastly/a1dab4bf5e5557cd3c45c0b485b3201ca4677e919c306ffbe6fd9617e46dd170.jpeg",
    "https://cdn.faire.com/fastly/8a7ae192094a72114667b03dd18e2d36761c6f707f37072f8d1277c0ae6139c8.jpeg",
    "https://cdn.faire.com/fastly/2bb681da0ceb7e7782ce4db1cbfeacb9eafcbda93a36c66753871d7bac71a22a.jpeg",
    "https://cdn.faire.com/fastly/d0e7f53d782be3d6dd929b5283fb5b730886fd9a7cb8ac81c6843745e43c5468.jpeg",
    "https://cdn.faire.com/fastly/931e2f04aec668171169ead6519a89e92a771519a837d4d17314ee3329598ede.jpeg",
    "https://cdn.faire.com/fastly/51babca331be74fae74577f258cc87d650e5a14961e8cd6890ed3fa92309cd31.jpeg",
    "https://cdn.faire.com/fastly/49eb8098227d572482aceec0059156008a1ab4672921f67a4e0b91423c3a0342.jpeg",
    "https://cdn.faire.com/fastly/d00d46c4b8d0f085ded0170c8110ffe6ef14cfd3b50e05666a5246ae6a5407bb.jpeg",
  ],
  priceDollars: 8.22,
  description:
    'Our bracelets are handmade with high quality beads. \nAdult bracelet - Standard size- Fits wrist size 7" comfortably \n\n',
  tags: [],
  msrpDollars: 16.44,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:41.446Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
